"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _scale = _interopRequireDefault(require("./scale"));
/**
 * Get run lineGap
 *
 * @param  {Object}  run
 * @return {number} lineGap
 */


var lineGap = function lineGap(run) {
  var _run$attributes, _run$attributes$font;

  return (((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.lineGap) || 0) * (0, _scale["default"])(run);
};

var _default = lineGap;
exports["default"] = _default;